<template>
    <div>
        <b-card :header="headerTitle" :header-tag="headingSize" class="bg-primary-card shadow-none text-dark">
            <div v-if="chartLoaded">
                <IEcharts :option="mixed" ref="chart" class="overflow-auto" style="height: 430px;"></IEcharts>
            </div>
            <div v-else>
                <p class="mb-0 text-dark">
                    <i class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i> {{$t('general.projects.progress.no_steps')}}
                </p>
            </div>
        </b-card>
    </div>
</template>

<script>
import Vue from 'vue';
import IEcharts from 'vue-echarts-v3/src/full.js';
import 'echarts/lib/chart/line';

export default {
    name: 'triple_bar_chart',
    components: {
        IEcharts,
    },
    props: {
        headerTitle: {
            type: String,
            default: ''
        },
        headingSize: {
            type: String,
            default: 'h3'
        },
        chartSeries: {
            type: Array,
            default: function() {
                return []
            }
        },
        chartxAxis: {
            type: Array,
            default: function() {
                return []
            }
        },
        chartLegend: {
            type: Array,
            default: function() {
                return []
            }
        },
        chartLoaded: {
            type: Boolean,
            default: false
        },
        chartColor: {
            type: Array,
            default: function () {
                return ['#4F81BD', '#C0504D',  '#81a33c'];
            }
        },
    },
    data() {
        return {
            mixed: {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    height: 250,
                    top: 150,
                    bottom: -200,
                    right: '7%'
                },
                toolbox: {
                    show: true,
                    feature: {
                    }
                },
                calculable: true,
                legend: {
                    orient: 'vertical',
                    data: this.chartLegend
                },
                color: this.chartColor,
                xAxis: [
                    {
                        type: 'category',
                        name: '',
                        data: this.chartxAxis
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        },
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    }
                ],
                series: this.chartSeries
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/common/charts/triple_bar_chart.vue